<template>
  <ion-card id="temps-forts">
    <ion-card-header>
      <ion-card-title>Temps forts</ion-card-title>
    </ion-card-header>

    <ul class="timeline">
      <li class="event">
        <h3>Transition énergétique</h3>
        <p>
          Un quiz interactif permettra aux élèves de découvrir les métiers en lien avec la transition énergétique.
          Sur place, les conseillers en orientation guideront chacun dans la réflexion sur les parcours
          professionnels possibles dans ce domaine en pleine évolution.
        </p>
        <NavigateButton id-ilot="18">Emplacement du stand</NavigateButton>
        <div>
          <ion-button
              color="warning"
              href="https://quiz-metiers-transition-energetique.ch/"
          >
            <ion-icon :icon="linkSharp" slot="start"></ion-icon>
            <ion-label>quiz transition energetique</ion-label>
          </ion-button>
        </div>
      </li>
      <li class="event">
        <h3>Entretiens fictifs</h3>
        <p>
          Un entretien fictif de 45 minutes permettra aux élèves de s’entraîner aux entretiens d’embauche.
          Encadrés par des coachs, ils bénéficieront d’un retour détaillé et de conseils concrets pour
          perfectionner leur candidature.
        </p>
      </li>
      <li class="event">
        <h3>Réseaux sociaux</h3>
        <p>M. Stéphane Koch sera présent le mercredi après-midi pour dialoguer et échanger
          sur le thème des réseaux sociaux dans l’enseignement, la formation et l’apprentissage, ainsi que sur
          l’utilisation de l’intelligence artificielle.</p>
      </li>
      <li class="event">
        <h3>Egalité entre femmes et hommes</h3>
        <p>Un stand mobile qui voyagera entre les stands et les villages
          avec pour concept général : « Ouvrez le champ des possibles » et « Osez les métiers, cassez les codes ».</p>
      </li>
      <li class="event">
        <h3>Développement des métiers de la santé</h3>
        <p>Neuf professions seront présentées.</p>
        <NavigateButton id-ilot="83">Emplacement du stand</NavigateButton>
      </li>
      <li class="event">
        <h3>Métiers techniques</h3>
        <p>Bepog te permet de découvrir les métiers techniques</p>
        <div>
          <ion-button
              color="warning"
              href="https://new.bepog.ch/"
          >
            <ion-icon :icon="linkSharp" slot="start"></ion-icon>
            <ion-label>bepog.ch</ion-label>
          </ion-button>
        </div>
      </li>
      <li class="event">
        <h3>Eliminatoires pour agents d'exploitation</h3>
        <p>Concours de participants provenant de la Suisse romande durant tout le Salon</p>
        <NavigateButton id-ilot="39">Emplacement du concours</NavigateButton>
      </li>
      <li class="event">
        <h3>Concours Robots-JU</h3>
        <p>Démonstrations le mercredi après-midi 4 mars et concours le samedi 7 mars.</p>
        <NavigateButton id-ilot="23">Emplacement du concours</NavigateButton>
        <div>
          <ion-button
              color="warning"
              href="https://robots-ju.ch/"
          >
            <ion-icon :icon="linkSharp" slot="start"></ion-icon>
            <ion-label>robots-ju.ch</ion-label>
          </ion-button>
        </div>
      </li>
      <li class="event">
        <h3>Formation continue</h3>
        <p>Les prestataires de la formation continue pour adultes proposent des formations
          allant des compétences de base à des brevets, en passant par des formations reconnues.</p>

        <div>
          <h2>Pour le Jura</h2>
          <ion-button
              color="primary"
              href="https://www.avenirformation.ch/home"
          >
            <ion-icon :icon="linkSharp" slot="start"></ion-icon>
            <ion-label>avenirformation.ch</ion-label>
          </ion-button>

          <h2>Berne francophone</h2>
          <ion-button
              color="primary"
              href="https://www.cip-tramelan.ch/"
          >
            <ion-icon :icon="linkSharp" slot="start"></ion-icon>
            <ion-label>cip-tramelan.ch</ion-label>
          </ion-button>
          <ion-button
              color="primary"
              href="https://www.ceff.ch/"
          >
            <ion-icon :icon="linkSharp" slot="start"></ion-icon>
            <ion-label>ceff.ch</ion-label>
          </ion-button>
        </div>

      </li>
    </ul>
  </ion-card>
</template>

<script>
import NavigateButton from './NavigateButton'
import {
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle, IonIcon, IonLabel
} from "@ionic/vue";
import { linkSharp, filmOutline } from "ionicons/icons";

export default {
  name: 'Timeline',
  components: {
    NavigateButton,
    IonCard,
    IonCardTitle,
    IonCardHeader,
    IonButton,
    IonLabel,
    IonIcon
  },
  setup() {
    return {
      linkSharp, filmOutline
    };
  }
}
</script>

<style lang="scss">
/* Source : https://codepen.io/alanhouser/pen/aErrQJ?editors=0100#0 */
/* Variables */

$background: white;

$color-primary: #e30613;
$color-light: white;
$color-dark: #373636;
$color-dim: #6c6d6d;
$spacing: 20px;
$radius: 4px;

$date: 120px;
$dotborder: 4px;
$dot: 11px;
$line: 4px;

/*$font-title: 'Saira', sans-serif;
$font-text: 'Chivo', sans-serif;*/

/* Base */

#temps-forts {
  background: $background;
  padding-bottom: 2em;

  /* Timeline */
  .red {
    color: $color-primary;
  }
  .timeline {
    list-style: none;

    /*font-family: $font-text;*/
    font-size: 1rem;
    line-height: 1.4em;

    text-align: left;

    border-left: $line solid $color-primary;
    border-bottom-right-radius: $radius;
    border-top-right-radius: $radius;
    /*background: rgba($color-dark, 3%);*/
    /*margin: 0 0 0 80px;
    width: calc(100% - 80px);*/
    margin: 0 0 0 $spacing;
    position: relative;
    padding: 0 10px 0 $spacing;

    h2, h3 {
      color: $color-dark;
    }

    .event {
      border-bottom: 1px dashed rgba($color-dark, 10%);
      padding-bottom: ($spacing * 0.5);
      margin-bottom: $spacing;
      position: relative;

      &:last-of-type {
        padding-bottom: 0;
        margin-bottom: 0;
        border: none;
      }

      &:before, &:after {
        position: absolute;
        display: block;
        top: 0;
      }

      &:before {
        left: ((($date * 0.6) + $spacing + $line + $dot + ($dotborder * 2)) * 1.5) * -1;
        color: $color-dark;
        content: attr(data-date);
        text-align: right;
        font-weight: 100;
        font-size: 0.9em;
        min-width: $date;
        /*font-family: $font-title;*/
      }

      &:after {
        box-shadow: 0 0 0 $dotborder rgba($color-primary, 100%);
        left: ($spacing + $line + ($dot * 0.35)) * -1;
        background: lighten($background, 5%);
        border-radius: 50%;
        height: $dot;
        width: $dot;
        content: "";
        top: 5px;
      }
    }
  }
}
</style>
